var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRodadas(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7CD58A96-BD8D-4CBC-9195-BDB39B33E7CE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.1-home-aba/carreira-juridica",
    transform: "translate(-24.000000, -744.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-principal",
    transform: "translate(24.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-rodadas",
    transform: "translate(0.000000, 512.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    fillOpacity: 0,
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "loop-2",
    transform: "translate(1.000000, 2.000000)",
    fill: "#1717CE",
    fillRule: "nonzero",
    stroke: "#1717CE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "loop"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5982308,9.83141646 L22,9.83141646 C22.0051207,4.40681853 17.6186924,0.00513776292 12.2025804,0 C7.04798512,-0.00490933251 2.76940512,3.98778007 2.41033434,9.13785976 L0.991047617,7.71634931 L0,8.70824771 L3.01379403,11.7267637 L6.02758805,8.70824771 L5.03373691,7.71634931 L3.82751841,8.9244577 C4.33552669,4.30007363 8.49031335,0.96369209 13.1075071,1.47249631 C17.3653673,1.94172637 20.5909592,5.54113122 20.5982308,9.83141646 Z",
    id: "Path",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74683544,19.4132139 C10.2482184,19.5420097 10.7586117,19.6326288 11.2735553,19.6842105 L11.4177215,18.2415519 C10.9761225,18.1976237 10.538488,18.1198661 10.1086926,18.0089586 L9.74683544,19.4132139 Z",
    id: "Path",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.44749948,13.122807 L3.20253165,13.6432686 C3.38921781,14.0908994 3.60970896,14.5236175 3.86210832,14.9376633 L5.01265823,14.2326744 C4.79650861,13.877603 4.60758845,13.5065629 4.44749948,13.122807 Z",
    id: "Path",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96202532,18.1213672 C7.4012301,18.3980376 7.86106502,18.6404869 8.33736786,18.8465845 L8.91139241,17.5150856 C8.50245421,17.3381779 8.10772185,17.1299045 7.73076941,16.8921239 L6.96202532,18.1213672 Z",
    id: "Path",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78829989,15.216872 L4.73417722,16.1120606 C5.05439461,16.4912869 5.40310647,16.8454161 5.77724749,17.1713326 L6.6835443,16.1259073 C6.36229075,15.8463772 6.0629693,15.5424856 5.78829989,15.216872 Z",
    id: "Path",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4050633,16.3700433 L18.2667651,17.4505412 C18.6547727,17.1406085 19.018422,16.8011336 19.3544304,16.435192 L18.3358671,15.4960806 C18.0481005,15.8106483 17.7369256,16.1027778 17.4050633,16.3700433 Z",
    id: "Path",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6708861,18.3130966 L12.7453174,19.6842105 C13.2353091,19.6572167 13.722484,19.5923459 14.2025316,19.4901979 L13.9184636,18.1485629 C13.5074271,18.2354144 13.0903303,18.2904303 12.6708861,18.3130966 Z",
    id: "Path",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0759494,14.5545726 L20.2660742,15.3564763 C20.5530753,14.9282195 20.8069178,14.4784959 21.0253165,14.0113475 L19.7262164,13.4020157 C19.5393632,13.8023837 19.3219503,14.187752 19.0759494,14.5545726 Z",
    id: "Path",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1772152,17.7095737 L15.6627759,18.9861889 C16.1197766,18.81103 16.5626464,18.6006941 16.9873418,18.3571024 L16.3110981,17.1713326 C15.9473532,17.3794912 15.5682856,17.5594314 15.1772152,17.7095737 Z",
    id: "Path",
    strokeWidth: 0.3
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRodadas);
export default __webpack_public_path__ + "static/media/ic-rodadas.5761fcba76b45d868d472a39a1c8c082.svg";
export { ForwardRef as ReactComponent };